import styled from '@emotion/styled';

export const StyledFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 20px 0 12px 0;

  & > div {
    background-color: #fff;
  }

  & > section {
    background-color: #fff;
    border-radius: 4px;
    margin-left: 0;
  }

  & > * + * {
    margin-left: 10px !important;
  }
`;
